
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeMbGrid extends Serenity.EntityGrid<PsDiscCouponTypeMbRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeMbColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeMbDialog; }
        protected getIdProperty() { return PsDiscCouponTypeMbRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeMbRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeMbRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeMbService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}